// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Automated Reminders container - same structure as WhatsApp Invoice */
.automated-reminders {
  padding: 0;
  width: 100%;
}

/* Sub-tabs: modern pill / segmented style */
.automated-reminders-sub-tabs {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px;
  margin-bottom: 16px;
  background: #f1f5f9;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  width: -moz-fit-content;
  width: fit-content;
}

.automated-reminders-tab-item {
  padding: 10px 24px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: #64748b;
  background: transparent;
  border-radius: 8px;
  transition: all 0.2s ease;
  -webkit-user-select: none;
          user-select: none;
}

.automated-reminders-tab-item:hover {
  color: #1e40af;
  background: rgba(30, 64, 175, 0.08);
}

.automated-reminders-tab-active {
  font-weight: 600;
  color: #fff !important;
  background: #1e40af !important;
  box-shadow: 0 1px 3px rgba(30, 64, 175, 0.3);
}

.automated-reminders-tab-active:hover {
  color: #fff !important;
  background: #1d4ed8 !important;
}

/* Panel below tabs */
.automated-reminders-panel {
  padding-top: 4px;
}

/* Tab content wrapper */
.automated-reminders-tab-content {
  width: 100%;
  min-height: 200px;
}

/* Toolbar (button / search) above table */
.automated-reminders-toolbar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

/* Loading state - match WhatsApp Invoice */
.automated-reminders-loading {
  display: flex;
  justify-content: center;
  padding: 60px 0;
}

/* Error state */
.automated-reminders-error {
  padding: 40px 20px;
  text-align: center;
  color: #c62828;
  font-size: 0.9375rem;
}

/* Placeholder for Bills & Reminders History */
.automated-reminders-placeholder {
  padding: 48px 24px;
  text-align: center;
  color: #94a3b8;
  font-size: 0.9375rem;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px dashed #e2e8f0;
}

.automated-reminders-placeholder p {
  margin: 0;
}

/* Even row height for all table rows (Reminder, Bills, Reminders History) */
.automated-reminders .MuiTableBody-root .MuiTableRow-root {
  min-height: 48px;
}

.automated-reminders .MuiTableBody-root .MuiTableRow-root .MuiTableCell-root {
  min-height: 48px;
  padding-top: 12px;
  padding-bottom: 12px;
  box-sizing: border-box;
  vertical-align: middle;
}

.automated-reminders .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root {
  min-height: 44px;
  padding-top: 10px;
  padding-bottom: 10px;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/components/HospitalNotices/AutomatedReminders.css"],"names":[],"mappings":"AAAA,uEAAuE;AACvE;EACE,UAAU;EACV,WAAW;AACb;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;;AAEA,4EAA4E;AAC5E;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB","sourcesContent":["/* Automated Reminders container - same structure as WhatsApp Invoice */\n.automated-reminders {\n  padding: 0;\n  width: 100%;\n}\n\n/* Sub-tabs: modern pill / segmented style */\n.automated-reminders-sub-tabs {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px;\n  margin-bottom: 16px;\n  background: #f1f5f9;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  width: fit-content;\n}\n\n.automated-reminders-tab-item {\n  padding: 10px 24px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  color: #64748b;\n  background: transparent;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  user-select: none;\n}\n\n.automated-reminders-tab-item:hover {\n  color: #1e40af;\n  background: rgba(30, 64, 175, 0.08);\n}\n\n.automated-reminders-tab-active {\n  font-weight: 600;\n  color: #fff !important;\n  background: #1e40af !important;\n  box-shadow: 0 1px 3px rgba(30, 64, 175, 0.3);\n}\n\n.automated-reminders-tab-active:hover {\n  color: #fff !important;\n  background: #1d4ed8 !important;\n}\n\n/* Panel below tabs */\n.automated-reminders-panel {\n  padding-top: 4px;\n}\n\n/* Tab content wrapper */\n.automated-reminders-tab-content {\n  width: 100%;\n  min-height: 200px;\n}\n\n/* Toolbar (button / search) above table */\n.automated-reminders-toolbar {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n/* Loading state - match WhatsApp Invoice */\n.automated-reminders-loading {\n  display: flex;\n  justify-content: center;\n  padding: 60px 0;\n}\n\n/* Error state */\n.automated-reminders-error {\n  padding: 40px 20px;\n  text-align: center;\n  color: #c62828;\n  font-size: 0.9375rem;\n}\n\n/* Placeholder for Bills & Reminders History */\n.automated-reminders-placeholder {\n  padding: 48px 24px;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 0.9375rem;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px dashed #e2e8f0;\n}\n\n.automated-reminders-placeholder p {\n  margin: 0;\n}\n\n/* Even row height for all table rows (Reminder, Bills, Reminders History) */\n.automated-reminders .MuiTableBody-root .MuiTableRow-root {\n  min-height: 48px;\n}\n\n.automated-reminders .MuiTableBody-root .MuiTableRow-root .MuiTableCell-root {\n  min-height: 48px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  box-sizing: border-box;\n  vertical-align: middle;\n}\n\n.automated-reminders .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root {\n  min-height: 44px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
